module.exports = __webpack_public_path__ + "img/card-select-type-joynet-icon.fedc2762.svg";